import React, { useEffect, useState } from "react";
import NotificationDivStyle from "./NotificationDivStyle.component";
import { IFileData } from "./NotificationModal.component";
import "./Notification.styles.css";
import AutoScroll from "../AutoScroll/AutoScroll.component";
import { useFetch } from "../../hooks/useFetch";
import { usePost } from "../../hooks/usePost";
import {
  API_Notification,
  API_Notify,
  GetAllNotification_M3,
  GetPulishedNotification,
  IGetNotificationReq,
} from "../../api/notifyapi/Notifyapi";
import UpArrow from "../../assets/up-arrow-svg.svg";
import DownArrow from "../../assets/down-arrow-svg.svg";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux-store/store";
import {
  INotificationTableList,
  IUINotification_View_3,
} from "../../slices/NotificationSlice";
import { stat } from "fs";
import { showErrorNotification } from "../Mangement/modal/Tostify";
import FlashNotificationDivStyle from "./FlashNotificationDivStyle.component";
import CloseIcon from "@mui/icons-material/Close";
interface INotificationData {
  userId: string;
  roles: string[];
  partnerId: string;
}

interface IFlashNotificationPorps {
  onClose: () => void;
}

const FlashNotifications: React.FC<IFlashNotificationPorps> = ({ onClose }) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [canShowFlashNotify,setShowFlashNotify] = useState<boolean>(false);

  const getIsModalOpen = (isModal: boolean) => {
    setIsModalOpen(isModal);
  };

  const getModalIsclose = () => {
    onClose();
  };
  const [isPauseNotification, setIsPauseNotification] =
    useState<boolean>(false);
  const [moveNotificationToTop, setMoveNotificationToTop] =
    useState<boolean>(false);
  const [moveNotificationToBottom, setMoveNotificationToBottom] =
    useState<boolean>(false);

  const notificationDataList = useSelector(
    (state: RootState) => state.notification.PublishedNotifications
  );

  const onMouseOverPauseNotification = () => {
    setIsPauseNotification(true);
  };

  const onMouseOutStartNotification = () => {
    setIsPauseNotification(false);
  };

  const moveNotifToTopHandler = () => {
    setMoveNotificationToTop(true);
    setInterval(() => {
      setMoveNotificationToTop(false);
    }, 500);
  };
  const moveNotifToBottomHandler = () => {
    setMoveNotificationToBottom(true);
    setInterval(() => {
      setMoveNotificationToBottom(false);
    }, 500);
  };

  const getFileName = (file: any): string => {
    if (file != null && file != undefined && file?.length > 0) {
      const fileName: string = file.split("\\").pop()?.split("/").pop() || "";
      return fileName;
    }
    return "";
  };

  useEffect(()=>{
    var showFlashNots = false;

    if(notificationDataList?.length > 0){
      if(notificationDataList.find(x=> x.category == "CRITICAL")){
        showFlashNots = true;
      }
    }

    setShowFlashNotify(showFlashNots);
  },[notificationDataList])

  return (
    <>
      {
      canShowFlashNotify && <div className="flash-notification-container">
        <div className="flash-notificaion-header">
        <div className="flash-notificaion-label">
          <label>Critical Notification(s)</label>
        </div>
        <div style={{ margin: "4px 10px" }} onClick={getModalIsclose}>
          <CloseIcon
            style={{ fontSize: "35px", cursor: "pointer" }}
          />
        </div>
        </div>
        
        <div className="flash-notification-list">
          {notificationDataList?.map(
            (notification: IUINotification_View_3, index: number) =>
              notification.category == "CRITICAL" ? (
                <FlashNotificationDivStyle
                  getModalIsOpen={getIsModalOpen}
                  key={index}
                  header={notification.title}
                  description={notification.description}
                  files={notification?.attachments}
                  notificationId={notification.notificationID}  

                />
              ) : (
                <></>
              )
          )}
        </div>
       
      </div>
      }
    </>
  );
};

export default FlashNotifications;
